import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "static-footer",
  templateUrl: "./static-footer.component.html",
  styleUrls: ["./static-footer.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StaticFooterComponent {
  year = new Date().getFullYear();
}
